<nav id="nav-desktop" class="nav-center hide-on-small-only">
  <div class="nav-wrapper container">
    <!-- <a href="#" class="brand-logo right">Logo</a> -->
    <ul class="right">
      <li (click)="clickContact()"><a>Contacto</a></li>
    </ul>
    <ul class="left sound-icon">
      <li (click)="toggleSound()"><a><span class="material-icons">{{sound}}</span></a></li>
    </ul>
    <ul id="nav-mobile" class="center">
      <li><a routerLink="/home/" routerLinkActive="active" >Inicio</a></li>
      <li><a routerLink="/what/">Que</a></li>
      <li><a routerLink="/how/">Cómo</a></li>
    </ul>
  </div>
</nav>

<ul class="nav-mobile hide-on-med-and-up" id="nav-mobile-s">
  <li></li>        
  <li class="menu-container"> 
    <input id="menu-toggle" type="checkbox" >
    <label for="menu-toggle" class="menu-button">
      <i class="small material-icons icon-open">dehaze</i>
      <i class="small material-icons icon-close">close</i>
    </label>      
    <ul class="menu-sidebar">
      <li class="sound-icon" (click)="toggleSound()"><a><i class="material-icons">{{sound}}</i></a></li>
      <li class="menu-option"><a routerLink="/home/" routerLinkActive="active" ><i class="material-icons">home</i>  <span>Inicio</span> </a></li>
      <li class="menu-option"><a routerLink="/what/"><i class="material-icons">color_lens</i>  <span>Que</span> </a></li>
      <li class="menu-option"><a routerLink="/how/"><i class="material-icons">fireplace</i>  <span>Cómo</span> </a></li>
      <li class="menu-option" (click)="clickContact()"><a><i class="material-icons">mail</i> <span>Contacto</span> </a></li>
      <div class="social-menu animated" id="social-menu">
        <a class="waves-effect waves-light social facebook" href="https://www.facebook.com/romaef/" target="_blank">
          <i class="fa fa-facebook"></i>
        </a>
        <a class="waves-effect waves-light social instagram" href="https://www.instagram.com/romaef_/" target="_blank">
          <i class="fa fa-instagram"></i>
        </a>
        <a class="waves-effect waves-light social github" href="https://github.com/RomarioAugustoEstradaFlorez" target="_blank">
          <i class="fa fa-github"></i>
        </a>
        <a class="waves-effect waves-light social behance" href="https://www.behance.net/romarioestrada" target="_blank">
          <i class="fa fa-behance"></i>
        </a>
      </div>
      <div class="contact-info">
        <div class="section">
          <div>
            <i  class="material-icons left">settings_cell</i> <span>+57 321 254 62 65</span> 
          </div>
          <div>
            <i  class="material-icons left">mail</i> <span>romaef23@gmail.com</span> 
          </div>
        </div>
      </div>
      <!-- <li>
        <input type="checkbox" id="sub-one" class="submenu-toggle">        
        <label class="submenu-label" for="sub-one">Category</label>
        <div class="arrow right">&#8250;</div>           
        <ul class="menu-sub">
          <li class="menu-sub-title">
            <label class="submenu-label" for="sub-one">Back</label>
            <div class="arrow left">&#8249;</div>              
          </li>        
          <li><a href="#">Sub-item</a></li>
          <li><a href="#">Sub-item</a></li>
          <li><a href="#">Sub-item</a></li>
          <li><a href="#">Sub-item</a></li>                                
        </ul>
      </li>
      <li>
        <input type="checkbox" id="sub-two" class="submenu-toggle">        
        <label class="submenu-label" for="sub-two">Category</label>
        <div class="arrow right">&#8250;</div> 
        <ul class="menu-sub">
          <li class="menu-sub-title">
            <label class="submenu-label" for="sub-two">Back</label>
            <div class="arrow left">&#8249;</div>              
          </li>      
          <li><a href="#">Sub-item</a></li>
          <li><a href="#">Sub-item</a></li>
          <li><a href="#">Sub-item</a></li>     
          <li><a href="#">Sub-item</a></li>                                
        </ul>              
      </li>                                          -->
    </ul> 

    
  </li>
</ul>
<div id="loading" class="loadingDiv">
  <div class="logo row">
    <div class="col s10 offset-s1 m4 offset-m4 l4 offset-l4">
      <img class="responsive-img" src="../assets/img/logo_loading.png" alt="">
    </div>
  </div>
  <div id="loadingAnimation" class="animated">
    <div class="loading">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
  </div>
</div>
<router-outlet></router-outlet>